import { type DeviceFragment, DeviceGeneralStatus } from '@cobliteam/api-lib/src/__generated__/graphql';
import { useTranslation } from '@cobliteam/i18n';
import { Typography } from '@cobliteam/ui/components';
import { formatRelativeDate } from '@cobliteam/utils/date';

interface VehiclePopupDelayTextProps {
  currentDevice?: DeviceFragment;
}

const VehiclePopupDelayText = ({ currentDevice }: VehiclePopupDelayTextProps) => {
  const { t } = useTranslation('monitoring');
  const { lastLocation, generalStatus } = currentDevice || {};

  if (!lastLocation) return null;

  const lastStatusInMillis = lastLocation?.timeInMillis || 0;
  const updateLabel = generalStatus === DeviceGeneralStatus.Disconnected ? t('vehicle_popup_delay.disconnection_date') : t('vehicle_popup_delay.update');
  const delayText = formatRelativeDate(lastStatusInMillis);

  return (
    <div className='flex items-center gap-1 leading-sm'>
      <Typography variant='description-list-medium' color='secondary'>
        {updateLabel}
      </Typography>
      <Typography variant='description-list-default' color='secondary'>
        {delayText}
      </Typography>
    </div>
  );
};

export default VehiclePopupDelayText;
